import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Pensé que no iba a funcionar… y en días dejé de obsesionarme.',
    author: 'Camila',
    age: '27 años'
  }, {
    text: 'Dejé de stalkearlo y de escribirle. Volví a estar tranquila.',
    author: 'Lucía',
    age: '31 años'
  }, {
    text: 'Es como terapia, pero directa. Me cambió la cabeza.',
    author: 'Valentina',
    age: '25 años'
  }, {
    text: 'Volví a elegirme. Eso fue lo más importante.obvio que no es magia , si no pones voluntad el libro no puede hacer todo pero es una ayuda fundamental. cuando me siento mal me lo llevo en la cartera . Lo imprimi',
    author: 'Rocío',
    age: '29 años'
  }, {
    text: 'No podía dejar de pensar en él… ahora ya no me afecta.',
    author: 'Sofía',
    age: '34 años'
  }];
  return <section className="bg-white py-12 md:py-16 px-4" data-id="element-194">
      <div className="max-w-6xl mx-auto" data-id="element-195">
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-10 text-center" data-id="element-196">
          💬 Lo que dicen otras mujeres
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-197">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-purple-50 border-2 border-purple-200 rounded-lg p-6 shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-198">
              <div className="flex gap-1 mb-4" data-id="element-199">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-200" />)}
              </div>
              <p className="text-gray-800 mb-4 italic" data-id="element-201">"{testimonial.text}"</p>
              <p className="font-bold text-purple-900" data-id="element-202">
                — {testimonial.author}, {testimonial.age}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}